import axios from 'axios'
import store from '../store'
import {AUTH_LOGOUT} from '../store/actions/auth'
import {router} from '../main.js'
import NProgress from 'vue-nprogress'
import _ from "lodash";
import { Notification } from 'element-ui';
import moment from 'moment'
export const api = axios.create()
// Set the AUTH token for any request
const nprogress = new NProgress({ parent: '.nprogress-container' })

const req = ''
api.interceptors.request.use(function (config) {
//config.baseURL = 'https://data-staging.tefl.org'
config.baseURL = process.env.SERVER_URL
//config.params=reuest.params
  //axios.defaults.withCredentials = true
  const token = localStorage.getItem('jwt_token')
  nprogress.start() 

  if (token) {
    //config.params['user_session'] = token;
    config.headers.Authorization = 'Bearer ' + token
   
  }
  return config
})
// show alert when not logged in
api.interceptors.response.use(function (response) {
/*   if(!response.data.data ){
    Notification.error({title:'Whoops',message:response.status+' : No data returned',duration:0}) 
  } */
  nprogress.done()
console.log(response.errors)
  return response
}, function (error) {

  if (error.response.status === 555 || error.response.status === 403) {
    nprogress.done()
    store.dispatch(AUTH_LOGOUT)
    Notification.error({title:'Whoops',message:'login error',duration:0})
    router.push('/login?')
    return error.response
  } else if (error.response.status === 404) {
    nprogress.done()

 Notification.error({title:'Whoops',message:error.response.status+' : '+error.response.data.error_message,duration:0})
    return error.response
  } else {
    nprogress.done()
    return Promise.reject(error)
    
  }
})
export const commonApi={
  getCountries:() => new Promise((resolve, reject) => {
    api.get('/countries/')
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  getClassroomsByTown:({...args}) => new Promise((resolve, reject) => {
    console.log(args)
    let dateFrom='';
    let dateTo='';
   if(args.dates){
    dateFrom = moment(args.dates[0]).format('YYYY/MM/DD')
    dateTo=moment(args.dates[1]).format('YYYY/MM/DD')
   }
   if (!args.town){
    args.town=''
   }
   api.get('/classroom/filter?town='+args.town+'&dateFrom='+dateFrom+'&dateTo='+dateTo)
    .then(function (response) {
      resolve(response)
    })
    .catch((error) => {
      reject(error)
    }) 
}),

getTownsByCountry:({...args}) => new Promise((resolve, reject) => {
    console.log(args)
   api.get('/venues/towns_by_country?countryId='+args.country)
    .then(function (response) {
      resolve(response)
    })
    .catch((error) => {
      reject(error)
    }) 
}),
getVenuesByTown:(arg) => new Promise((resolve, reject) => {
  console.log(arg)
 api.get('/venues/filter?town='+arg)
  .then(function (response) {
    resolve(response)
  })
  .catch((error) => {
    reject(error)
  }) 
}),

getUserLongnameById:(id) => new Promise((resolve, reject) => {
    console.log('getting tutor ',id)
   api.get('/users/'+id+'/longname')
    .then(function (response) {
      resolve(response)
    })
    .catch((error) => {
      reject(error)
    }) 
})
,

getUserById:(id) => new Promise((resolve, reject) => {
    console.log('getting tutor ',id)
   api.get('/users/'+id)
    .then(function (response) {
      resolve(response)
    })
    .catch((error) => {
      reject(error)
    }) 
}),

uploadAvatar:(image) => new Promise((resolve, reject) => {

 api.post('/users/avatar',image)
  .then(function (response) {
    resolve(response)
  })
  .catch((error) => {
    reject(error)
  }) 
}),

changePassword:(args) => new Promise((resolve, reject) => {
  api.post('/users/password', args)
  .then(function (response) {
    resolve(response)
  })
  .catch((error) => {
    reject(error)
  })
}),

}



// WEBPACK FOOTER //
// ./src/api/common.js